import { v4 as uuidv4 } from "uuid";

export class WRAntrag {
  id: string;
  title: string;
  text: string;
  backend_expanded: boolean = false;
  status: WRAntragStatus;
  date: string;

  constructor(
    title: string = "",
    text: string = "",
    backend_expanded: boolean = false
  ) {
    this.id = uuidv4();
    this.title = title;
    this.text = text;
    this.backend_expanded = backend_expanded;
    this.status = WRAntragStatus.DRAW;
    let new_date = new Date();
    this.date = new_date.getDate()+"."+(new_date.getMonth()+1)+"."+new_date.getFullYear(); // Date.now().toString();
  }
}

export enum WRAntragStatus {
  DRAW,
  IN_VORBEREITUNG,
  IN_EINBRINGUNG,
  IN_PRUEFUNG,
  IN_DISKUSSION,
  IN_ABSTIMMUNG,
  VERABSCHIEDET,
  ABGELEHNT,
  IN_UMSETZUNG
}